<!-- Botón flotante draggable -->
<div
  class="chat-button-draggable cdk-drag"
  cdkDrag
  [cdkDragBoundary]="'.drag-boundary'"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragEnded)="onDragEnded()"
   (click)="onButtonClick()"
>
  <i class="fas fa-comments"></i>
</div>

<div class="drag-boundary"></div>


<div
  *ngIf="mostrarChat"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
  "
  (click)="cerrarChat()"
>
  <div
    style="
      width: 90vw;
      height: 90vh;
      background-color: white;

      border-radius: 10px;
      position: relative;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
      display: flex;
      flex-direction: column;
    "
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div
      style="
        background-color: #202945;
        color: white;
        padding: 10px 20px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
    >
      <span class="fw-bold">Asistente Virtual</span>
      <button
        (click)="mostrarChat = false"
        class="btn btn-sm"
        title="Cerrar"
        style="
          background-color: #f5edf0;
          border-color: #e7dade;
          color: #080202;
        "
      >
        &times;
      </button>
    </div>

    <!-- Iframe del chat -->
    <iframe
      [src]="iframeChat | safeUrl"
      style="
        flex-grow: 1;
        width: 100%;
        border: none;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      "
    ></iframe>
  </div>
</div>